<template>
  <div id="modifiersPriorityEdit">
    <TipBox info :title="$t('tips.display_priority')">
      <span v-html="$t('tips.display_priority_description')"></span>
    </TipBox>
    <Panel :title="$t('display_priority')">
      <Draggable v-model="items"  @start="drag=true" @end="drag=false">
        <div v-for="select in items" class="item-checkbox-line">
          <svgicon src="icon/hamburger.svg" :height="12" :width="12"></svgicon>
          <label :for="`chk_${select.id}`">{{getItemName(select.id)}}</label>
          <tag v-if="select.note">{{ select.note }}</tag>
        </div>
      </Draggable>
    </Panel>
    <div class="footer-actions" v-if="!$store.getters.isBranchContextInventory">
      <button class="btn btn-primary" @click="save">{{$t("save")}}</button>
    </div>
  </div>
</template>
<script>
  import { Core } from "@/core/Core";
  import Draggable from 'vuedraggable';
  import { mapActions } from 'vuex';

  export default {
    name: "ModifierPriority",
    components: { Draggable },

    data() {
      return {
        ready: false,
        inventory: null,
        items: [],
        data: {
          id: null,
          type: "",
          selected: [],
          itemPriorities: {},
        }
      }
    },

    computed: {
      inventoryReference() {
        return this.$store.state.contextCompany ? this.$store.state.contextCompany.nameCanonical : this.inventory.id;
      }
    },

    async mounted() {
      this.inventory = await this.$store.getters.getContextInventory;
      Promise
        .all([
          Core.request("GET", `/api/inventory/${this.inventoryReference}/modifiers?augment=backend`),
        ])
        .then(([modifiers]) => {
          console.log('done with promise' + modifiers);
          this.items = modifiers;
        })
        .finally(() => {
          this.$store.commit('showSpinner', false);
        })

    },

    methods: {

      ...mapActions(['saveItemsPriorities']),

      getItemName(id) {
        for (let item of this.items) {
          if (item.id === id) {
            return this.$to(item.name);
          }
        }
      },
      async save() {
        this.$store.commit("showSpinner", true);
        let response = await this.saveItemsPriorities({inventoryId: this.inventoryReference, data: {items: this.items}});
        if (!response) {
          toast(this.$t("modifiers.error.save"), "error");
          this.$store.commit("showSpinner", false);
          return;
        }
        this.$store.commit("showSpinner", false);
      }
    }
  }
</script>

<style lang="scss" scoped>
.item-checkbox-line {
  background-color: #f2f2f2;
  margin: 5px 0;
  border-radius: 6px;
  padding: 10px;
  display: flex;
  align-items: center;
  cursor: grab;
  max-width: 900px;

  &:not(:last-child) {
    margin-bottom: 5px;
  }

  label {
    flex-grow: 1;
  }

  .svgicon {
    fill: #ccc;
    margin-right: 20px;
  }

  .tag {
    text-transform: none;
    font-weight: normal;
    border-radius: 6px;
    padding: 4px 10px;
    font-size: 14px;
  }
}
</style>
